import { ArrowRight, Users } from "lucide-react";

interface Props {
  toSlug: string | null;
  taskDescription?: string | null;
}

export function DelegationBlock({ toSlug, taskDescription }: Props) {
  return (
    <div className="my-2 flex items-start gap-2 rounded-md border-l-2 border-blue-500 bg-blue-50/40 px-3 py-2 dark:bg-blue-950/20">
      <Users className="mt-0.5 h-4 w-4 shrink-0 text-blue-700" />
      <div className="flex-1 text-sm">
        <div className="flex items-center gap-2">
          <span className="font-medium text-blue-900 dark:text-blue-200">
            Supervisor
          </span>
          <ArrowRight className="h-3 w-3 text-blue-700" />
          <code className="font-mono text-xs">
            @{toSlug ?? "(desconhecido)"}
          </code>
        </div>
        {taskDescription ? (
          <details className="mt-1 text-xs text-muted-foreground">
            <summary className="cursor-pointer">
              {taskDescription.slice(0, 80)}
              {taskDescription.length > 80 ? "..." : ""}
            </summary>
            <p className="mt-1 whitespace-pre-wrap">{taskDescription}</p>
          </details>
        ) : null}
      </div>
    </div>
  );
}
